import makeStyles from "@mui/styles/makeStyles";

export const useStyles = makeStyles(() => ({
  root: {
    listStyle: "none",
    margin: 0,
    padding: 0,
  },
}));
